import { ContextualTabbedSettings } from '@components'

import { Accordion, RadioButton, XStack, YStack } from '@shinetools/lumen-react'
import { FileKey } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { LearnMoreTranslation } from '@features/eInvoicingSettings/elements/networks/elements/LearnMoreTranslation'

import { AddressingLineDefaultProps, AddressingLineFormat } from './types/frAddressingLinesFormats'

const { ContextualSettingInput } = ContextualTabbedSettings

interface AddressingLineSelectorProps extends AddressingLineDefaultProps {
  addressingLine?: string
}

export const AddressingLineSelector = ({
  addressingLine,
  addressingLineFormat = AddressingLineFormat.SIREN,
  onAddressingLineFormatChange,
}: AddressingLineSelectorProps) => {
  const { t } = useTranslation()

  return (
    <YStack>
      <ContextualSettingInput
        isLoading={false}
        icon={FileKey}
        label={t('einvoicing.settings.fr.upcoming_addressing_line', {
          addressingLine: addressingLine ?? '-',
        })}
        description={
          <LearnMoreTranslation
            i18nKey="einvoicing.settings.fr.addressing_line_hint"
            linkKey="einvoicing.settings.fr.addressing_line_hint_link"
          />
        }
      />

      <Accordion title={t('einvoicing.settings.fr.enrolment.advanced_addressing_line')}>
        <div style={{ marginTop: '1rem' }}>
          <XStack>
            <RadioButton
              checked={addressingLineFormat === AddressingLineFormat.SIREN}
              label={t('einvoicing.settings.fr.enrolment.advanced_addressing_line.siren')}
              name="addressingLineFormat"
              onChange={() => {
                onAddressingLineFormatChange(AddressingLineFormat.SIREN)
              }}
            />
            <RadioButton
              checked={addressingLineFormat === AddressingLineFormat.SIREN_SIRET}
              label={t('einvoicing.settings.fr.enrolment.advanced_addressing_line.siren_siret')}
              name="addressingLineFormat"
              onChange={() => {
                onAddressingLineFormatChange(AddressingLineFormat.SIREN_SIRET)
              }}
            />
          </XStack>
        </div>
      </Accordion>
    </YStack>
  )
}
